<template>
    <div id="africa-page">

        <div class="jumbotron jumbotron-big text-center" style="background: url(assets/crealco/background-africa-ujv.jpg); background-size: cover; background-position: left center;">

		<div class="white position-absolute top-0 row h-100 w-100 justify-content-center align-items-center text-center margin-right-left-0">

			<div class="jumbo-info">

				<h1 class="text-uppercase font-xl white text-shadow">Welcome <br>to UJV Africa</h1> 

			</div>

		</div> 

    	<!--<div class="controllers-cont">

    		<div class="next-section-anchor"><a><i class="material-icons">arrow_downward</i></a>

    		</div>

    	</div>-->

    </div>


    <div style="background: white; overflow: hidden;">                                                                                                                                                                 
        <div class="container pb-1">

           <h2 class="bd-title section-title default-letter-spacing font-lg text-center font-weight-normal">Out Top Partners</h2>


           <div class="row text-center pb-4">    		

              <div class="col-md-2 mb-1">
                 <div class="py-4 rounded-xl" style="">
                    <img src="assets/crealco/logo-belmond-safari.jpg" style="max-width: 222px; width: 100%" class="mx-auto mb-">
                </div>
            </div>

            <div class="col-md-2 mb-1">
                <div class="py-4 rounded-xl" style="">
                    <img src="assets/crealco/logo-singita.jpg" style="max-width: 222px; width: 100%" class="mx-auto mb-">
                </div>
            </div>

            <div class="col-md-2 mb-1">
                <div class="py-4 rounded-xl" style="">
                    <img src="assets/crealco/logo-royal-malewane.jpg" style="max-width: 222px; width: 100%" class="mx-auto mb-">
                </div>
            </div>

            <div class="col-md-2 mb-1">
                <div class="py-4 rounded-xl" style="">
                    <img src="assets/crealco/logo-silo.jpg" style="max-width: 222px; width: 100%" class="mx-auto mb-">
                </div>
            </div>

            <div class="col-md-2 mb-1">
                <div class="py-4 rounded-xl" style="">
                    <img src="assets/crealco/logo-one-and-only.jpg" style="max-width: 180px; width: 100%" class="mx-auto mb-">
                </div>
            </div>

            <div class="col-md-2 mb-1">
                <div class="py-4 rounded-xl" style="">
                    <img src="assets/crealco/logo-more.jpg" style="max-width: 222px; width: 100%" class="mx-auto mb-">
                </div>
            </div>	

        </div>

    </div>

</div>

<div style="background: #0071bc;">

   <section class="container pb-4 pt-1">

    <h2 class="bd-title section-title default-letter-spacing font-lg text-center font-weight-normal text-white">Explore Our Destinations</h2>

    <div class="row text-center justify-content-md-center">        

        <div class="col-md-3 mb-4">
            <div class="card" style="">
              <img class="card-img-top" src="assets/crealco/Bostwana.jpg" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title" style="color: #0071bc">Botswana</h5>
                <a href="../destinations/botswana" class="btn btn-primary btn-sm">View destination</a>
              </div>
            </div>
        </div>

        <div class="col-md-3 mb-4">
            <div class="card" style="">
              <img class="card-img-top" src="assets/crealco/Kenya.jpg" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title" style="color: #0071bc">Kenya</h5>
                <a href="../destinations/kenya" class="btn btn-primary btn-sm">View destination</a>
              </div>
            </div>
        </div>

        <div class="col-md-3 mb-4">
            <div class="card" style="">
              <img class="card-img-top" src="assets/crealco/Rwanda.jpg" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title" style="color: #0071bc">Rwanda</h5>
                <a href="../destinations/rwanda" class="btn btn-primary btn-sm">View destination</a>
              </div>
            </div>
        </div>

        <!-- <div class="col-md-3 mb-4">
            <div class="card" style="">
              <img class="card-img-top" src="assets/crealco/Seychells.jpg" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title" style="color: #0071bc">Seychells</h5>
                <a href="../destinations/botswana" class="btn btn-primary btn-sm">View destination</a>
              </div>
            </div>
        </div> -->

        <div class="col-md-3 mb-4">
            <div class="card" style="">
              <img class="card-img-top" src="assets/crealco/South-Africa.jpg" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title" style="color: #0071bc">South Africa</h5>
                <a href="../destinations/south-africa" class="btn btn-primary btn-sm">View destination</a>
              </div>
            </div>
        </div>        

    </div>

    <div class="row text-center justify-content-md-center">

        <div class="col-md-3 mb-4">
            <div class="card" style="">
              <img class="card-img-top" src="assets/crealco/Tanzania.jpg" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title" style="color: #0071bc">Tanzania</h5>
                <a href="../destinations/tanzania" class="btn btn-primary btn-sm">View destination</a>
              </div>
            </div>
        </div>

        <div class="col-md-3 mb-4">
            <div class="card" style="">
              <img class="card-img-top" src="assets/crealco/Zambia.jpg" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title" style="color: #0071bc">Zambia</h5>
                <a href="../destinations/zambia" class="btn btn-primary btn-sm">View destination</a>
              </div>
            </div>
        </div>

        <div class="col-md-3 mb-4">
            <div class="card" style="">
              <img class="card-img-top" src="assets/crealco/Zimbabwe.jpg" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title" style="color: #0071bc">Zimbabwe</h5>
                <a href="../destinations/zymbabwe" class="btn btn-primary btn-sm">View destination</a>
              </div>
            </div>
        </div>        

    </div>

</section>

</div>

<div class="container pb-3 pt-4">

    <h2 class="bd-title section-title default-letter-spacing text-uppercase font-md text-center font-weight-bold" style="margin-bottom: 1.5rem; margin-top: 1.5rem;">Meet Our Team</h2>

    <!--<div class="row text-center">

        <div class="col-md-3"></div>

        <div class="col-md-3 mb-4">
            <div style="background: #eee" class="p-3 pt-4 rounded-lg">
                <img src="assets/crealco/bjorn.jpg" class="mx-auto mb-2">
                <span class="d-block">Bjorn Van Huyssteen</span>
            </div>
        </div>

        <div class="col-md-3 mb-4">
            <div style="background: #eee" class="p-3 pt-4 rounded-lg">
                <img src="assets/crealco/melissa.jpg" class="mx-auto mb-2">
                <span class="d-block">Melissa Accocella</span>
            </div>
        </div>

        <div class="col-md-3"></div>

    </div>-->

    <div class="row">

        <div class="col-md-4"></div>

        <div class="col-md-4 mb-1">
            <div class="box-element bg-white box-shadow d-flex flex-column rounded">
                <div class="box-element-image">
                    <a href="#" data-toggle="modal" data-target="#agentModal" class="zoom-image rounded-top">
                        <span class="zoom-image-hover"></span> 
                        <img src="assets/crealco/Bjorn-Van-Huyssteen.jpg" alt="Bjorn Van Huyssteen" class="width-100 rounded-top">
                    </a>
                </div> 
                <div class="box-element-info">
                    <div class="row">
                        <div class="col-auto mr-auto">
                            <h3 class="font-md margin-0">Bjorn Van Huyssteen</h3> 
                            <p>UJV Advisor</p> 
                            <!--<p>305-830-0200 x 
                            <span><strong>4400</strong></span></p>-->
                        </div> 
                        <!--<div class="col-auto">
                            <a href="mailto:diana@ultimatejetvacations.com" class="font-md link-style d-block">
                                <i class="material-icons">mail</i></a>
                        </div>-->
                    </div>
                </div> 
                <div class="box-element-link text-center mt-auto">
                    <a href="#" data-toggle="modal" data-target="#agentModal" class="font-weight-bold font-md link-style">See full profile</a>
                </div>
            </div>
        </div>

        <div class="col-md-2"></div>

    </div>

</div>


<!-- Agent Details Modal -->
        <div class="modal fade" id="agentModal" tabindex="-1" role="dialog" aria-labelledby="agentModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header modal-header-gradient rounded-top">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                <i class="material-icons d-none d-md-inline-block">close</i>
                                <i class="material-icons d-md-none">arrow_back</i>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <img class="width-100 rounded-top" src="assets/crealco/Bjorn-Van-Huyssteen.jpg">
                        <div class="modal-body-content">
                            <div class="row">
                                <div class="col-auto mr-auto">
                                    <h3 class="font-md margin-0">Bjorn Van Huyssteen</h3>
                                    <p>UJV Advisor</p>
                                    <!--<p>305-830-0200 x <span><strong>4488</strong></span></p>-->
                                </div>
                                <!--<div class="col-auto">
                                    <a href="mailto:diana@ujv.com" class="font-md link-style d-block">
                                        <i class="material-icons">mail</i>
                                    </a>
                                </div>-->
                            </div>
                            <hr>
                            <p class="text-justify">Born and raised in Cape Town, South Africa, I have 27 years of luxury travel experience to Southern and East Africa.  I was in the first enrolment class of Tourism in the university town of Stellenbosch in the Cape Winelands when the bug really bit.  </p>
 
<p class="text-justify">I have in these years worked on the most amazing luxury celebrity, honeymoon, family holidays, FIT’s and private jet itineraries.  </p>
 
<p class="text-justify">I have intense experience in South Africa, Namibia, Zimbabwe, Zambia, Botswana, Kenya, Tanzania, Uganda and Rwanda.</p>
 
<p class="text-justify">One itinerary is never the same for me and tailor making it to the tee, a passion.</p>
                            <h3 class="font-md">Favorite hotels</h3>
                            <ul class="list-check">
                                <li>Cape Grace Hotel<u></u><u></u></li>
 	<li>One and Only Cape Town</li>
 	<li>The Silo</li>
 	<li>The Residence</li>
 	<li>Birkenhead House</li>
 	<li>Sabi Sabi Private Game Reserve</li>
 	<li>Mala Mala Private Game Reserve</li>
 	<li>Londolozi Private Game Reserve</li>
 	<li>Lion Sands Ivory Lodge</li>
 	<li>Royal Malewane Private Game Reserve</li>
 	<li>Phinda Private Game Reserve</li>
 	<li>Ol Seki Hemingways Mara</li>
 	<li>Mahali Mzuri</li>
 	<li>Elewana Collection</li>
 	<li>Four Seasons Safari Lodge</li>
                            </ul>
                            <div class="row">
                                <!--<div class="col-12 col-md-6">
                                    <h3 class="font-md">Favorite destinations</h3>
                                    <ul class="list-check">
                                        <li>Sanci</li>
                                    </ul>
                                </div>-->
                                <div class="col-12 col-md-6">
                                    <h3 class="font-md">Recently visited</h3>
                                    <ul class="list-check">
                                        <li>Botswana</li>
 	<li>Zambia</li>
 	<li>Zimbabwe</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- END Agent Details Modal -->
        
</div>

</template>

<script>
    export default {
        components: { },
    }
</script>

<style>
    .rounded-xl{
        border-radius: .5em;
    }
</style>
